var CmsModel = require('tscom-cms');

module.exports = CmsModel.extend({

    parse: function(response) {
        //etags: 304 response
        if( response === undefined ) {
            return undefined;
        }
        response = CmsModel.prototype.parse.call( this, response );

        var data = response.data;

        for(var i = 0; i < data.length; i++) {
            data[i].image = data[i].image.replace(/^http:\/\//i, 'https://');
        }

        response.data = data;

        console.log(response);

        response.windowStatus = parseInt(response.settings.window_status);

        return response;
    }

});



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/models/cms.js
// module id = 189
// module chunks = 0